import { TileLayerSourceFormat } from '@/services/map-services/enums';
import TileLayer from 'ol/layer/Tile';
import { OSM, XYZ } from 'ol/source';
export var BasemapOptions;
(function (BasemapOptions) {
    BasemapOptions["OSM"] = "Open Street Map";
    BasemapOptions["ESRI_WORLD_TOPO"] = "ESRI World Topo";
    BasemapOptions["ESRI_IMAGERY"] = "ESRI World Imagery";
    BasemapOptions["ESRI_STREET"] = "ESRI World Street";
    BasemapOptions["ESRI_TERRAIN"] = "ESRI World Terrain";
    BasemapOptions["ESRI_USA_TOPO"] = "USA Topo Map";
    BasemapOptions["ESRI_WORLD_DARK"] = "ESRI World Dark";
    BasemapOptions["ESRI_WORLD_LIGHT"] = "ESRI World Light";
    BasemapOptions["ESRI_OCEAN"] = "ESRI World Ocean";
    BasemapOptions["NATGEO"] = "NatGeo World";
})(BasemapOptions || (BasemapOptions = {}));
const options = [
    {
        title: BasemapOptions.OSM,
        category: 'Basemap',
        visible: false,
        distribution: {
            format: TileLayerSourceFormat.OSM,
        },
    },
    {
        title: BasemapOptions.ESRI_WORLD_TOPO,
        category: 'Basemap',
        visible: false,
        distribution: {
            format: TileLayerSourceFormat.XYZ,
            accessURL: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
        },
    },
    {
        title: BasemapOptions.ESRI_IMAGERY,
        category: 'Basemap',
        visible: false,
        distribution: {
            format: TileLayerSourceFormat.XYZ,
            accessURL: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        },
    },
    {
        title: BasemapOptions.ESRI_STREET,
        category: 'Basemap',
        visible: false,
        distribution: {
            format: TileLayerSourceFormat.XYZ,
            accessURL: 'https://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
        },
    },
    {
        title: BasemapOptions.ESRI_TERRAIN,
        category: 'Basemap',
        visible: false,
        distribution: {
            format: TileLayerSourceFormat.XYZ,
            accessURL: 'https://services.arcgisonline.com/arcgis/rest/services/World_Terrain_Base/MapServer/tile/{z}/{y}/{x}',
        },
    },
    {
        title: BasemapOptions.ESRI_USA_TOPO,
        category: 'Basemap',
        visible: false,
        distribution: {
            format: TileLayerSourceFormat.XYZ,
            accessURL: 'https://services.arcgisonline.com/arcgis/rest/services/USA_Topo_Maps/MapServer/tile/{z}/{y}/{x}',
        },
    },
    {
        title: BasemapOptions.NATGEO,
        category: 'Basemap',
        visible: false,
        distribution: {
            format: TileLayerSourceFormat.XYZ,
            accessURL: 'https://services.arcgisonline.com/arcgis/rest/services/NatGeo_World_Map/MapServer/tile/{z}/{y}/{x}',
        },
    },
    {
        title: BasemapOptions.ESRI_WORLD_DARK,
        category: 'Basemap',
        visible: false,
        distribution: {
            format: TileLayerSourceFormat.XYZ,
            accessURL: 'https://services.arcgisonline.com/arcgis/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}',
        },
    },
    {
        title: BasemapOptions.ESRI_WORLD_LIGHT,
        category: 'Basemap',
        visible: true,
        distribution: {
            format: TileLayerSourceFormat.XYZ,
            accessURL: 'https://services.arcgisonline.com/arcgis/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
        },
    },
    {
        title: BasemapOptions.ESRI_OCEAN,
        category: 'Basemap',
        visible: false,
        distribution: {
            format: TileLayerSourceFormat.XYZ,
            accessURL: 'https://services.arcgisonline.com/arcgis/rest/services/Ocean/World_Ocean_Base/MapServer/tile/{z}/{y}/{x}',
        },
    },
];
function createBasemapLayerList(layers) {
    const tileLayers = [];
    layers.forEach((layer) => {
        switch (layer.distribution.format) {
            case TileLayerSourceFormat.OSM:
                tileLayers.push(new TileLayer({
                    visible: layer.visible,
                    source: new OSM(),
                    properties: {
                        name: layer.title,
                        basemap: true,
                    },
                }));
                break;
            case TileLayerSourceFormat.XYZ:
                tileLayers.push(new TileLayer({
                    visible: layer.visible,
                    source: new XYZ({
                        url: layer.distribution.accessURL,
                    }),
                    properties: {
                        name: layer.title,
                        basemap: true,
                    },
                }));
                break;
        }
    });
    return tileLayers;
}
export default createBasemapLayerList(options);
